export default __webpack_public_path__ + "static/media/washupBirthdayNewsBanner.cabcff50.png";